export const REPLAYS_AVAILABLE_INFO_MESSAGE_TEXT = {
    id: 'oe.meeting.replaysAvailableInfoMessage',
    description: 'Info Message',
    defaultMessage: `If this toggle is enabled, the meeting will appear on the Replays page in Passport once the meeting end time is in the past.
        You can only enable this toggle if the Meeting Access is Open or Plenary.`
};

export const FEATURED_MEETING_INFO_MESSAGE_TEXT = {
    id: 'oe.meeting.featuredMeetingInfoMessage',
    description: 'Info Message',
    defaultMessage: 'Featured Presentations are displayed as larger cards on both the General Sessions and Replays pages in Passport.'
};

export const AUDIENCE_CAPACITY_INFO_MESSAGE_TEXT = {
    id: 'oe.meeting.audienceCapacityInfoMessage',
    description: 'Info Message',
    defaultMessage: 'This toggle controls how many attendees can Register for this meeting or Book this meeting in Passport (only Participant and Registrant roles are part of this count).'
};

export const MEETING_LOADING_DATA_TEXT = {
    id: 'oe.meeting.loadingData',
    defaultMessage: 'loading meeting data{suffix}',
    description: 'Label text'
};

export const RUN_MEETING_TEXT = {
    id: 'oe.meeting.runMeeting',
    defaultMessage: 'Run Meeting',
    description: 'Label text'
};

export const MEETING_DELETE_TEXT = {
    id: 'oe.meeting.meetingDelete',
    defaultMessage: 'Delete Meeting',
    description: 'Label text'
};

export const EDIT_MEETING_CONNECTIONS_TEXT = {
    id: 'oe.meeting.editMeetingConnections',
    defaultMessage: 'Edit Meeting Connections',
    description: 'Label text'
};

export const MEETING_CHANGE_END_DATE_TEXT = {
    id: 'oe.meeting.changeEndDate',
    description: 'Button text',
    defaultMessage: 'Change end date'
};

export const ADD_MEETING_TIME_TEXT = {
    id: 'oe.schedule.addMeetingTime',
    defaultMessage: '{prefix}Add Meeting Time',
    description: 'Button text'
};

export const MEETING_TEMPLATE_SUFFIX_TEXT = {
    id: 'oe.meeting.template',
    defaultMessage: 'Meeting Template{suffix}',
    description: 'label'
};

export const MEETING_TEMPLATE_TEXT = {
    id: 'oe.meeting.template',
    defaultMessage: 'Meeting Template',
    description: 'label',
};

export const NO_TEMPLATE_SELECTED_TEXT = {
    id: 'oe.templates.noTemplateSelected',
    description: 'Label text',
    defaultMessage: 'No Template Selected',
};

export const MEETING_STATUS_TEXT = {
    id: 'oe.meeting.status',
    defaultMessage: 'Meeting Status',
    description: 'Label text'
};

export const MEETING_SCHEDULED_TEXT = {
    id: 'oe.meeting.scheduled',
    defaultMessage: 'Scheduled',
    description: 'Option label'
};

export const MEETING_CANCELLED_TEXT = {
    id: 'oe.common.cancelled',
    defaultMessage: 'Cancelled',
    description: 'Option label'
};

export const MEETING_REMOVED_TEXT = {
    id: 'oe.common.removed',
    defaultMessage: 'Removed',
    description: 'Option label'
};

export const MEETING_ACCESS_TEXT = {
    id: 'oe.meeting.access',
    defaultMessage: 'Meeting Access',
    description: 'Label text'
};

export const MEETING_CLOSED_TEXT = {
    id: 'oe.meeting.closed',
    defaultMessage: 'Closed',
    description: 'Option label'
};

export const MEETING_OPEN_TEXT = {
    id: 'oe.meeting.open',
    defaultMessage: 'Open',
    description: 'Button label text'
};

export const MEETING_PLENARY_TEXT = {
    id: 'oe.meeting.plenary',
    defaultMessage: 'Plenary',
    description: 'Option label'
};

export const MEETING_BOOKABLE_TEXT = {
    id: 'oe.meeting.bookable',
    defaultMessage: 'Bookable',
    description: 'Option label'
};

export const ENABLE_ON_REPLAYS_PAGE_TEXT = {
    message: '{prefix} available on Replays page',
    id: 'oe.meeting.enableOnReplaysPage',
    description: 'Label text'
};

export const AUDIENCE_CAPACITY_STATUS_TEXT = {
    message: 'Meeting audience capacity is {suffix}',
    id: 'oe.meeting.audienceCapacityStatus',
    description: 'Label text'
};

export const INVITE_ADDITIONAL_ATTENDEES_STATUS_TEXT = {
    message: 'Invite additional attendees is {suffix}',
    id: 'oe.meeting.inviteAdditionalAttendeesStatus',
    description: 'Label text'
};

export const INVITE_ADDITIONAL_ATTENDEES_INFO_MESSAGE_TEXT = {
    id: 'oe.meeting.inviteAdditionalAttendeesInfoMessage',
    description: 'Info Message',
    defaultMessage: 'This toggle controls if attendees who book this meeting will be given the option to invite additional attendees directly from Passport. Inviting attendees this way will be able to bypass audience capacity.'
};

export const AUDIENCE_CAPACITY_TEXT = {
    id: 'oe.meeting.audienceCapacity',
    defaultMessage: 'Meeting capacity',
    description: 'Label text'
};

export const AUDIENCE_ATTENDEES_TEXT = {
    id: 'oe.meeting.audienceAttendees',
    defaultMessage: 'audience attendees',
    description: 'Label text'
};

export const AUDIENCE_CAPACITY_RANGE_TEXT = {
    id: 'oe.meeting.audienceCapacityRange',
    defaultMessage: 'Please enter a number >= 1 and <= 99999',
    description: 'Tooltip text'
};

export const FEATURED_PRESENTATION_TEXT = {
    message: 'Featured Presentation',
    id: 'oe.meeting.featuredPresentation',
    description: 'Label text'
};

export const ATTENDEE_NEW_TEXT = {
    description: 'Label text',
    defaultMessage: '{prefix}New Attendee',
    id: 'oe.attendee.new'
};

export const MEETING_TRACK_TEXT = {
    id: 'oe.meeting.track',
    defaultMessage: 'Track',
    description: 'Label text'
};

export const SESSION_THUMBNAIL_IMAGE_TEXT = {
    id: 'oe.meeting.sessionThumbnailImage',
    defaultMessage: 'Session Thumbnail Image',
    description: 'Label text'
};

export const SESSION_HERO_IMAGE_TEXT = {
    id: 'oe.meeting.sessionHeroImage',
    defaultMessage: 'Session Hero Image',
    description: 'Label text'
};

export const NOTES_FOR_PASSPORT_TEXT = {
    id: 'oe.meeting.notesForPassport',
    defaultMessage: 'Meeting Notes (for OE Passport)',
    description: 'Label text'
};

export const MEETING_PATH_TEXT = {
    id: 'oe.meeting.path',
    defaultMessage: 'Path',
    description: 'Label text'
};

export const MEETING_PASSCODE_TEXT = {
    id: 'oe.meeting.passcode',
    defaultMessage: 'Passcode',
    description: 'Label text'
};

export const MEETING_LINK_TEXT = {
    id: 'oe.meeting.link',
    defaultMessage: 'Meeting Link',
    description: 'Label text'
};

export const LINK_WITH_EMBEDDED_PASSCODE_TEXT = {
    id: 'oe.meeting.linkWithEmbeddedPasscode',
    defaultMessage: 'Meeting Link with Embedded Passcode',
    description: 'Label text'
};

export const MEETING_ID_TEXT = {
    id: 'oe.meeting.Id',
    defaultMessage: 'Meeting ID',
    description: 'Label text'
};

export const MEETING_IS_BEING_SAVED_TEXT = {
    id: 'oe.meeting.meetingIsBeingSaved',
    description: 'Placeholder about saving meeting',
    defaultMessage: 'Meeting is being saved, please wait...',
};
